import { Component, OnDestroy, OnInit, QueryList, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgbdSortableHeader, SortEvent } from 'projects/Autofacets-Core/src/app/directives/sortable.directive';
import * as fromEnums from 'projects/Autofacets-Core/src/app/utils/enums';
import { BehaviorSubject, Subscription } from 'rxjs';
import { UserDataService } from 'src/app/DataServices/user-data.service';
import { CustomPaggerService } from './../../../../../Autofacets-Core/src/app/common-services/custom-pagger.service';
import { UserRoleViewModel } from './../../business-entities/user-role-view-model';
import { RolesRightsService } from './../../business-services/roles-rights.service';
import { EditRolesRightsComponent } from './edit-roles-rights/edit-roles-rights.component';
import { UserRoleMenu } from '../../business-entities/user-role-menu.model';
import { AddRolesRightsComponent } from './add-roles-rights/add-roles-rights.component';
import { SecureStorage } from '../../../../../Autofacets-Core/src/app/common-services/SecureStorage.service';
import { CurrentLanguage } from '../../../../../Autofacets-Core/src/app/common-services/current-language.service';
import { NgbdModalContent } from 'projects/Autofacets-Core/src/app/shared/delete-modal.component';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'app-roles-rights',
    templateUrl: 'roles-rights.component.html'
})
export class RolesRightsComponent implements OnInit, OnDestroy {

    allUserRoles: UserRoleViewModel[] = [];
    userRoles: any[] = [];
    loggedinUserRoleId: number;
    paginationSub: Subscription;
    userRoleRightsDetails: UserRoleMenu;
    subscription : Subscription;
    isAddRole:boolean = false;

    @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;

    constructor(
        public pService: CustomPaggerService,
        private rolesRightsService: RolesRightsService,
        public spinner: NgxSpinnerService,
        public router: Router,
        private userService: UserDataService,
        private modalService: NgbModal,
        private secureStorage: SecureStorage,
        private currentLanguageService: CurrentLanguage,
        private translate: TranslateService,
        config: NgbModalConfig
    ) {
        this.pService.searchby = ['roleName', 'isActive'];
        this.pService.searchTerm = '';
        this.pService.pageSize = 10;
        config.backdrop = 'static';
        config.keyboard = false;
    }

    ngOnInit() {
        this.pService.dataSource = [];
        this.userRoleRightsDetails = (this.userService.currentUserValue.userRoleMenuDetails as any[]).find(menu => menu.moduleId === fromEnums.ModuleNames.RolesRights);
        this.loggedinUserRoleId = this.userService.currentUserValue.roleType;
        this.getFeatures();
        this.getRoles();
    }

    async getRoles() {
        this.spinner.show();
        this.allUserRoles = await this.rolesRightsService.getRoles();
        this.spinner.hide();
        this.pService.dataSource = this.allUserRoles;
        this.paginationSub = this.pService.dealers$.subscribe((userRoles: UserRoleViewModel[]) => {
            this.userRoles = userRoles.map((role, index) => ({ ...role, row: this.currentPageNumber(index), isActive: role.isActive ? 'lblYes' : 'lblNot',isEnableStampIn:role.isEnableStampIn == "true" ? true:false }))
            if (this.loggedinUserRoleId === fromEnums.UserRoles.SuperUser){
                this.userRoles = this.userRoles?.filter((role) => role.id != fromEnums.UserRoles.SuperAdmin)
            }
        });
    }

    async getFeatures() {
        let features = this.secureStorage.getKeyData('feature');
        if(features == null || features == undefined){
          this.subscription = this.currentLanguageService.featureList.subscribe((res)=>{
            features = res;
            if (features?.length > 0) {
                this.isAddRole = features.find(x => x.featureCode === fromEnums.FeatureCode.AddRole)?.isActive;
            }
          })
        }
        else{
            this.isAddRole = features.find(x => x.featureCode === fromEnums.FeatureCode.AddRole)?.isActive;
        }
      }

    onEdit(role: UserRoleViewModel) {
        this.rolesRightsService.selectedRole = role;

        const modalref = this.modalService.open(EditRolesRightsComponent, { size: 'md', windowClass: 'EditPopup' });
        modalref.result.then((response) => {
            if (response.success) {
                //this is intentional
            }
        });
    }

    onAdd() {
        const modalref = this.modalService.open(AddRolesRightsComponent, { size: 'md', windowClass: 'EditPopup' });
        modalref.result.then((response) => {
          if (response.success) {
            this.ngOnInit();
          }
        });
      }

    onSort({ column, direction }: SortEvent) {
        this.headers.forEach(header => {
            if (header.sortable !== column) {
                header.direction = '';
            }
        });

        this.pService.sortColumn = column;
        this.pService.sortDirection = direction;
    }

    private currentPageNumber(cIndex: number): number {
        let rtPageNumber = 0;
        if (this.pService.page === 1) {
            rtPageNumber = cIndex + 1;
        }
        else if (this.pService.page > 1) {
            rtPageNumber = Number.parseInt(`${(this.pService.pageSize * (this.pService.page - 1))}`) + (cIndex + 1);
        }
        return rtPageNumber;
    }

    ngOnDestroy() {
        if (this.paginationSub) {
            this.paginationSub.unsubscribe();
          }
          this.pService.dealers$ = new BehaviorSubject<any[]>([]);
          this.pService.total$ = new BehaviorSubject<number>(0);
    }

    async stampInOutConfig(role:any){
        let modelHeadermsg = this.translate.instant("lblAreYouSureWantToUpdate");
        let modelBodymsg = this.translate.instant('lblAreYouSureWantToUpdateStampInOut');
        modelBodymsg = modelBodymsg.replace("{{RoleName}}",role.roleName);
        const modalRef = this.modalService.open(NgbdModalContent);
        modalRef.componentInstance.modelHeader = modelHeadermsg;
        modalRef.componentInstance.modelBody = modelBodymsg;
        modalRef.result.then((_result) => {
            // This is intentional
        }, async (reason) => {
            if (reason) {
                await this.rolesRightsService.updateStampInOutFeature(role).then((result)=>{
                    if(result.responseObject && (this.getUserObj.roleType == role.id)){
                        window.location.reload();
                    }
                });
            }
            else{
                role.isEnableStampIn = !role.isEnableStampIn;
            }
        });
    }

    get getUserObj() {
        return this.secureStorage.getKeyData(fromEnums.SecureStorageKey.GetUserDetails);
    }
}
